import NutrientViewer, {
  type Instance as NutrientInstance,
  type ViewState,
} from '@nutrient-sdk/viewer'
import { useLayoutEffect, useRef } from 'react'

import { useThemeMode } from '~app/components/GlobalContainer/ThemeModeProvider'
import { getLabelPresets } from '~app/configuration/labels'
import { config } from '../../config'

/**
 * Viewer global configurations
 */

NutrientViewer.Options.DISABLE_KEYBOARD_SHORTCUTS = true

/**
 * Viewer loader hook
 */

// The SDK exports its config only as the ServerConfiguration |
// StandaloneConfiguration union, and documentId lives on the server half, so
// the props this component forwards are declared directly.
interface Props {
  documentId: string
  initialViewState?: ViewState
  jwt: string
  loaded: (instance: NutrientInstance) => void
}

const PDFLoader = ({ documentId, jwt, loaded, ...configuration }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const { effectiveMode } = useThemeMode()
  useLayoutEffect(() => {
    if (!ref.current) {
      return undefined
    }

    NutrientViewer.unload(ref.current)
    NutrientViewer.load({
      ...configuration,
      container: ref.current,
      documentId,
      authPayload: {
        jwt,
      },
      serverUrl: config.PDFKitServerUrl,
      baseUrl: config.PDFKitBaseUrl,
      editableAnnotationTypes: [],
      annotationPresets: getLabelPresets(),
      instant: true,
      autoSaveMode: 'DISABLED',
      theme:
        effectiveMode === 'dark'
          ? NutrientViewer.Theme.DARK
          : NutrientViewer.Theme.LIGHT,
    }).then(loaded)
    return () => {
      if (ref.current) {
        NutrientViewer.unload(ref.current)
      }
    }
  }, [documentId, jwt, effectiveMode])
  return <div ref={ref} style={{ width: '100%', height: '1000px' }} />
}

export default PDFLoader
